"use client";
import React from "react";

export function IX3Provider({ children }) {
  return children;
}
